import { render, staticRenderFns } from "./screening-add-task-dialog.vue?vue&type=template&id=aea19612&scoped=true"
import script from "./screening-add-task-dialog.vue?vue&type=script&lang=js"
export * from "./screening-add-task-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-add-task-dialog.vue?vue&type=style&index=0&id=aea19612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea19612",
  null
  
)

export default component.exports